import { Link, useLocation, useNavigate } from 'react-router-dom';
import Vib3Mark from './Vib3Mark';
import { useStartAudit } from './useStartAudit';

const SECTION_LINKS = [
  { id: 'problem', label: 'Why audit' },
  { id: 'what', label: 'What you get' },
  { id: 'how', label: 'How it works' },
  { id: 'faq', label: 'FAQ', divided: true },
];

/**
 * Landing top nav, shared by the landing page and the legal documents. Section
 * links scroll in-page when already on `/`; from any other route they navigate
 * home first and then scroll to the section.
 */
export default function LandingNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const startAudit = useStartAudit();
  const onLanding = pathname === '/';

  const goSection = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onLanding) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      // Let the landing mount and settle (fonts/layout) before scrolling.
      window.setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 320);
    }
  };

  return (
    <nav>
      <div className="nav-in">
        <Link to="/" className="brand"><span className="mark"><Vib3Mark /></span>Vib3</Link>
        <div className="nav-links">
          {SECTION_LINKS.map((l) => (
            <span key={l.id} style={{ display: 'contents' }}>
              {l.divided && <span className="nav-div"></span>}
              <a href={`${onLanding ? '' : '/'}#${l.id}`} onClick={goSection(l.id)}>{l.label}</a>
            </span>
          ))}
        </div>
        <button className="btn btn-dark btn-sm" onClick={startAudit}>Get your audit <span className="arr">→</span></button>
      </div>
    </nav>
  );
}
